<template>
  <div class="bg-gray-10 px-4 py-10 md:py-20">
    <div class="w-full max-w-[70rem] mx-auto">
      <!-- eslint-disable vue/no-v-html -->
      <h2
        v-if="props.header"
        class="text-[1.75rem] leading-9 mb-4 md:mb-6 md:text-center md:text-4.5xl md:leading-12"
        v-html="props.header"
      >
      </h2>
      <p
        v-if="props.subHeader"
        class="text-sm mb-6 md:text-center md:mb-[1.625rem] md:text-lg md:leading-[1.625rem]"
        v-html="props.subHeader"
      >
      </p>
      <!-- eslint-enable vue/no-v-html -->
      <MoleculesCalculatorWithDisclaimer
        :calculator="calculator"
        :disclaimer="disclaimer"
        :buttons="[
          {
            theme: 'primary',
            text: 'Compare & save',
            url: verticalData?.formPage,
          }
        ]"
      />
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'CalculatorHomeLoan'
})

const _VERTICAL = VERTICAL.HOME_LOANS
const verticalData = VERTICALS[_VERTICAL]

const props = defineProps({
  header: {
    type: String,
    default: ''
  },

  subHeader: {
    type: String,
    default: ''
  },

  disclaimer: {
    type: Array,
    default: () => []
  },

  calculator: {
    type: String,
    default: '',
    validator: type => [
      'refinance',
      'borrowingPower',
      'stampDuty',
      'buyingCosts',
      'sellingCosts',
      'deposit',
      'budgetPlanner'
    ].includes(type)
  }
})
</script>
